export const NAME = 'paymentrequest';



// WEBPACK FOOTER //
// ./src/services/account/paymentrequest/constants.js